import { Component } from '@angular/core';
import { CroppieOptions } from "croppie";
import { ManageAdsBannerPhotoComponent } from "../../explore/components/ads-banner-photo/manage-ads-banner-photo.component";
import { Observable, of } from "rxjs";
import { FormGroup } from "@angular/forms";
import { FormlyFieldConfig } from "@ngx-formly/core";
import { LanguageConstant } from "../../../shared/constants/language-constant";
import {AdsSubTypeConstant, AdsTypeConstant, DisplayViewConstant} from "../../../shared/constants/ads-type-constant";

@Component({
    selector: 'app-advertising-photo',
    templateUrl: './advertising-photo.html',
})
export class AdvertisingPhotoComponent extends ManageAdsBannerPhotoComponent {
    currentPartner;
    filterMembersTags = null;
    testingMode = false;
    groupAdminView = false;
    id;
    subType = AdsSubTypeConstant.NORMAL;
    displayView = DisplayViewConstant.WEB;
    status = 'published';
    type = AdsTypeConstant.FEED_ADS;
    groupId;
    groupModel = {
        groupSearchValue : {}
    }
    language = LanguageConstant.NO;

    get appBannerValue() {
        return AdsSubTypeConstant.APP_BANNER
    }

    get normaSubtypeValue() {
        return AdsSubTypeConstant.NORMAL
    }

    public get croppieOptions(): CroppieOptions {
        const opts: CroppieOptions = {};

        opts.viewport = {
            width: 500,
            height: 500,
            type: 'square'
        };

        opts.boundary = {
            width: 500,
            height: 500,
        };

        opts.enforceBoundary = true;
        opts.showZoomer = false;
        opts.enableZoom = true;
        opts.mouseWheelZoom = false;

        return opts;
    }

    public get croppieAppBannerOptions(): CroppieOptions {
        const opts: CroppieOptions = {};

        opts.viewport = {
            width: 500,
            height: 281,
            type: 'square'
        };

        opts.boundary = {
            width: 500,
            height: 281,
        };

        opts.enforceBoundary = true;
        opts.showZoomer = false;
        opts.enableZoom = true;
        opts.mouseWheelZoom = false;

        return opts;
    }

    groupForm = new FormGroup({});
    groupFields: FormlyFieldConfig[] = [
        {
            key: 'groupSearchValue',
            type: 'autocomplete',
            className: 'form-mb-0',
            templateOptions: {
                type: 'text',
                placeholder: 'Find photo club by name',
                required: false,
                change: (field, event) => {
                },
                autoOptions: {
                    isMapIcon: false,
                    clearOption: true,
                    displayField: 'title',
                    selectItem: (event, model) => {
                        setTimeout(() => {
                            this.groupId = model.groupSearchValue.id
                        }, 100)
                    },
                    clearItem: (event, model) => {
                        setTimeout(() => {
                            this.groupId = null;
                            this.groupForm.controls['groupSearchValue'].setValue({})
                        }, 100)
                    },
                    inputFormatter: (x) => {
                        return (typeof x === 'object') ? x['title'] : x;
                    },
                    remoteData: (term) => {
                        return this.groupService.searchGroup(term);
                    },
                }
            },
        },
    ];

    public uploadBanner() {
        this.formData = new FormData();
        this.coverImage_file = new File([this.advertisingFileCropped], this.coverImage_file.name, {type: 'image/jpeg'});
        this.formData.append('advertising', this.coverImage_file, this.coverImage_file.name);
        const params = encodeURIComponent(JSON.stringify({
            navigateUrl: this.navigateUrl,
            partnerId : this.currentPartner,
            groupId : this.groupId,
            type: this.type,
            tags : this.filterMembersTags,
            language: this.language,
            status: this.status,
            subType: this.subType,
            displayView: this.displayView,
        }));

        if (this.formData) {
            if (!this.advertisingUrl) {
                this.http.post(ManageAdsBannerPhotoComponent.ADVERTISING_URL + 'advertising' + '/' + `?params=${params}`, this.formData)
                  .subscribe(
                    (res: any) => {
                        this.uploadSuccess.emit(res);
                        this.activeModal.close();
                    },
                    (error) => {
                        this.toastr.error(error.error.Message, 'Upload failed');
                    }
                  );
            } else {
                this.http.put(ManageAdsBannerPhotoComponent.ADVERTISING_URL + 'advertising' + '/' +
                  this.id + `?params=${params}`, this.formData)
                  .subscribe(
                    (res: any) => {
                        this.uploadSuccess.emit(res);
                        this.activeModal.close();
                    },
                    (error) => {
                        this.toastr.error(error.error.Message, 'Upload failed');
                    }
                  );
            }

        } else {
            this.toastr.error('Check your input and try again.', 'UPLOAD FAILED');
            this.failValidation();
        }
    }

    public onAdding(tag: string): Observable<any> {
        return of(tag.toLocaleLowerCase());
    }

    public onSubtypeChange(event) {
        if (this.subType == AdsSubTypeConstant.NORMAL || this.subType == AdsSubTypeConstant.APP_BANNER) {
            this.type = AdsTypeConstant.FEED_ADS;
        }

        if (this.subType == AdsSubTypeConstant.APP_BANNER) {
            this.displayView = DisplayViewConstant.APP;
            this.groupId = null;
        }
    }

    public updateInfo() {
        if (this.id) {
            this.http.put(ManageAdsBannerPhotoComponent.ADVERTISING_URL + '/' +
                this.id, {
                navigateUrl: this.navigateUrl,
                tags: this.filterMembersTags,
                subType: this.subType,
                displayView: this.displayView,
                groupId : this.groupId,
                type: this.type,
                language: this.language,
                status: this.status,
                partnerId : this.currentPartner,
            })
                .subscribe(
                    (res: any) => {
                        this.uploadSuccess.emit(res);
                        this.activeModal.close();
                    },
                    (error) => {
                        this.toastr.error(error.error.Message, 'Upload failed');
                    }
                );
        }
    }
}
